import Vue from "vue";
import Vuex from "vuex";
import Authentification from "./store/Authentification.js";
import Environnement from "@/store/Environnement";
import Demande from "@/store/Demande";
import Refus from "@/store/Refus";
import Application from "./store/Application.js";

Vue.use(Vuex);

// ..................................................................................................................................................................................................
// ...............................................................................STORE DE BASE......................................................................................................
// ..................................................................................................................................................................................................

// ..................................................................................NAMESPACE......................................................................................................
export default new Vuex.Store({
    namespaced: true,
    modules: {
        Authentification: Authentification,
        Environnement: Environnement,
        Demande: Demande,
        Refus: Refus,
        Application: Application
    }
});